import { render, staticRenderFns } from "./AdminNiveles.vue?vue&type=template&id=eb92e85e&"
import script from "./AdminNiveles.vue?vue&type=script&lang=js&"
export * from "./AdminNiveles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports